import { FC } from "react";
import { tw } from "twind";

// prettier-ignore
const COLORS_BACKGROUND = [
  "#e57373", "#f06292", "#ba68c8", "#9575cd", "#7986cb", "#64b5f6",
  "#4fc3f7", "#4dd0e1", "#4db6ac", "#81c784", "#aed581", "#dce775",
  "#fff176", "#ffd54f", "#ffb74d", "#ff8a65", "#a1887f", "#90a4ae"
];

// prettier-ignore
const COLORS_TEXT = [
  "#F44336", "#E91E63", "#9C27B0", "#673AB7", "#3F51B5", "#2196F3",
  "#03A9F4", "#00BCD4", "#009688", "#4CAF50", "#8BC34A", "#CDDC39",
  "#FFEB3B", "#FFC107", "#FF9800", "#FF5722", "#795548", "#607D8B"
];

const COLORS_BY_TYPE = {
  background: COLORS_BACKGROUND,
  text: COLORS_TEXT
};

interface Props {
  colorPalette: "background" | "text";
  value?: string;
  onChange: (color: string) => void;
  disabled?: boolean;
}

const ColorSwatchPicker: FC<Props> = ({ colorPalette, value, onChange, disabled }) => {
  const colors = COLORS_BY_TYPE[colorPalette];
  return (
    <div className={tw("flex flex-row flex-wrap")} role="listbox">
      {colors.map(c => (
        <button
          key={c}
          type="button"
          role="option"
          aria-selected={c === value}
          aria-label={c}
          disabled={disabled}
          style={{ background: c }}
          className={tw(
            "w-10 h-10 rounded-full cursor-pointer border-0 outline-none m-1",
            "transition-transform duration-150 hover:scale-125",
            c === value ? "ring-2 ring-offset-1 ring-blue-500" : ""
          )}
          onClick={() => onChange(c)}
        />
      ))}
    </div>
  );
};

export default ColorSwatchPicker;
